import * as React from "react";
import { List, ArrayField, Datagrid, SingleFieldList, ChipField, TextField, EmailField, EditButton, DeleteButton } from 'react-admin';

export const InternalList = props => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="_id" />
      <TextField source="label" />
      <EmailField source="email" />
      <ArrayField source="externals">
        <SingleFieldList>
          <ChipField source="label" />
        </SingleFieldList>
      </ArrayField>
      <EditButton basePath="/internals" />
      <DeleteButton basePath="/internals" />
    </Datagrid>
  </List>
);
